import styled from 'styled-components'

export const StyledCustomerTags = styled.ul`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
`
